import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=5bcf53b3"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports